/* eslint-disable no-nested-ternary */
/* eslint-disable no-eval */
import styled from 'styled-components';
import { AlertCircle as _AlertCircle } from '@carvana/icons';

export const AlertCircle = styled(_AlertCircle)`
  --size: ${props => props.size || '20px'};
  display: flex;

  & > svg {
    height: var(--size);
    width: var(--size);
  }

  & > svg > g {
    fill: ${props =>
      eval(
        `props.theme.carvana.${
          props.gray ? 'gray.light' : props.mediumblue ? 'blue.medium' : 'red.primary'
        }`
      )};
  }
`;

export default AlertCircle;
